import { BaseError } from '@dynamic-labs-sdk/client';

export class PublicKeyNotFoundError extends BaseError {
  constructor(address: string) {
    super({
      cause: null,
      code: 'public_key_not_found_error',
      docsUrl: null,
      name: 'PublicKeyNotFoundError',
      shortMessage: `No public key found for address ${address}`,
    });
  }
}

